<template>
  <section ref="statisticsSection" class="statistics-section" :class="{ 'statistics-section-mobile': isMobile }">
    <div class="transfer" id="limo">
      <div class="content">
        <div class="title">
          {{ $t('limo.title') }}
        </div>
        <div class="description">
          <p v-for="(line, index) in limo.description" :key="index">
            {{ line }}
          </p>
        </div>
        <div class="cards" ref="animateSection">
          <div class="single-card left">
            <img src="../assets/images/car-icons/mercedesS.png" alt="">
            <div class="car">
              <div class="title">Mercedes s class</div>
              <div class="sub-title">{{ $t('limo.info') }}</div>
            </div>
          </div>
          <div class="single-card left2">
            <img src="../assets/images/car-icons/maybach.png" alt="">
            <div class="car">
              <div class="title">maybach</div>
              <div class="sub-title">{{ $t('limo.info') }}</div>
            </div>
          </div>
          <div class="single-card right">
            <img src="../assets/images/car-icons/mercedesE.png" alt="">
            <div class="car">
              <div class="title">Mercedes e class</div>
              <div class="sub-title">{{ $t('limo.info') }}</div>
            </div>
          </div>
          <div class="single-card right2">
            <img src="../assets/images/car-icons/mercedesV.png" alt="">
            <div class="car">
              <div class="title">Mercedes v class</div>
              <div class="sub-title">{{ $t('limo.info') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="reservation-box">
        <h2 v-if="!submittedBox">{{ $t('reservation') }}</h2>
        <form v-if="!submittedBox" @submit.prevent="sendBox(formData)">
          <input type="text" v-model="formData.name" :placeholder="$t('footer.name')" required/>
          <input type="text" v-model="formData.contact" :placeholder="$t('footer.email')" required/>
          <textarea v-model="formData.message" rows="3" :placeholder="$t('footer.msg')"></textarea>
         <div class="flex">
           <a href="tel:+38269904274">
             <img src="../assets/images/ico2.png" alt="">
           </a>
           <a href="tel:+38269904274">
             <img src="../assets/images/ico3.png" alt="">
           </a>
           <a href="tel:+38269904274">
             <img src="../assets/images/ico4.png" alt="">
           </a>
           <button type="submit" class="btn">
             <span v-if="!isLoadingBox">{{ $t('footer.send') }}</span>
             <span v-else class="loader"></span>
           </button>
         </div>


        </form>
        <div v-if="submittedBox" class="confirmation box">
          <h2 v-if="!emailErrorBox">{{ $t('rentACar.form.reservationSuccess') }} </h2>
          <h2 v-else style="color: red;">{{ $t('rentACar.form.reservationFailed') }} </h2>
          <p v-if="!emailErrorBox" class="thank-you-msg">{{ $t('rentACar.form.success') }}</p>
          <p v-else class="thank-you-msg" style="color: red;">
            {{ $t('rentACar.form.tryAgain') }}
          </p>
          <br>
        </div>
        <div v-if="isLoadingBox" class="loader">
          <div class="spinner"></div>
        </div>
      </div>
    </div>
    <div class="tours" id="tours">
      <img src="../assets/images/tours-bg.png" alt="" class="background-image" loading="lazy">
      <div class="tours-content">
        <div class="section-title">{{ $t('tours.title') }}</div>
        <div class="description">
          <p v-for="(line, index) in tours.description" :key="index">
            {{ line }}
          </p>
        </div>
        <div class="title">{{ $t('popularDestinations') }}</div>
        <div class="cards">
          <div class="single-card">
            <img src="../assets/images/destinations/kotor.png" alt="">
            <p>bay of kotor - kotor - perast</p>
          </div>
          <div class="single-card">
            <img src="../assets/images/destinations/ostrog.png" alt="">
            <p>{{ $t('ostrog') }}</p>
          </div>
          <div class="single-card">
            <img src="../assets/images/destinations/tara.png" alt="">
            <p>{{ $t('rafting') }}</p>
          </div>
          <div class="single-card">
            <img src="../assets/images/destinations/dubrovnik.png" alt="">
            <p>dubrovnik</p>
          </div>
          <div class="single-card">
            <img src="../assets/images/destinations/skadarsko.png" alt="">
            <p>{{ $t('skadarsko') }}</p>
          </div>
          <div class="single-card">
            <img src="../assets/images/destinations/lovcen.png" alt="">
            <p>NP Lovćen</p>
          </div>
          <div class="single-card">
            <img src="../assets/images/destinations/biogradska.png" alt="">
            <p>NP Biogradska Gora</p>
          </div>
          <div class="single-card">
            <img src="../assets/images/destinations/budva.png" alt="">
            <p>budva - sveti stefan</p>
          </div>
          <div class="single-card">
            <img src="../assets/images/destinations/personal.png" alt="">
            <p>{{ $t('personal') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="quick-reserv">
      <div class="form-box">
        <div v-if="!submitted" class="title">{{ $t('quickReserve') }}</div>
        <form v-if="!submitted" @submit.prevent="sendEmail(reserve, 'Brza rezervacija')">
          <div class="form-group">
            <select v-model="reserve.name" required>
              <option value="" disabled selected hidden>{{ $t('footer.destination') }}</option>
              <option v-for="destination in destinations" :key="destination" :value="destination">
                {{ destination }}
              </option>
            </select>
            <input type="number" :placeholder="$t('footer.numOfPpl')" v-model="numOfPpl" required/>
          </div>
          <div class="form-group">
            <VueDatePicker
                class="picker"
                :enable-time-picker="true"
                :placeholder="$t('footer.date')"
                aria-required="true"
                :min-date="new Date()"
                v-model="reserve.date"
                teleport
                :format="customFormat"
            >
              <template #input-icon>
                <img class="input-slot-image"/>
              </template>

            </VueDatePicker>
            <input type="text" :placeholder="$t('rentACar.form.email')" v-model="reserve.contact" required/>
          </div>
          <button type="submit" class="btn">
            <span v-if="!isLoading">{{ $t('goOn') }}</span>
            <span v-else class="loader"></span>
          </button>
        </form>
        <div v-if="submitted" class="confirmation">
          <h2 v-if="!emailError">{{ $t('rentACar.form.reservationSuccess') }} </h2>
          <h2 v-else style="color: red;">{{ $t('rentACar.form.reservationFailed') }} </h2>
          <p v-if="!emailError" class="thank-you-msg">{{ $t('rentACar.form.success') }}</p>
          <p v-else class="thank-you-msg" style="color: red;">
            {{ $t('rentACar.form.tryAgain') }}
          </p>
          <br>
        </div>
        <div v-if="isLoading" class="loader">
          <div class="spinner"></div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import emailjs from "emailjs-com";


export default {
  name: 'LimoServiceSection',
  components: {
    VueDatePicker
  },
  data() {
    return {
      isMobile: false,
      isLoading: false,
      submitted: false,
      submittedBox: false,
      isLoadingBox: false,
      emailError: false,
      emailErrorBox: false,
      formData: {
        name: '',
        contact: '',
        date: 'Nema podataka o datumu',
        category: 'Limo',
        message: ''
      },
      reserve: {
        name: '',
        contact: '',
        date: '',
        category: 'Brza rezervacija',
        message: ''
      },
      dateTime: '',
      selectedDestination: '',
      destinations: [
        "Podgorica",
        "Tivat",
        "Kotor",
        "Budva",
        "Bar",
        "Herceg Novi",
        "Nikšić",
        "Ulcinj",
        "Žabljak"
      ],
      numOfPpl: ""
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$refs.animateSection.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(this.$refs.animateSection);
  },
  computed: {
    limo() {
      return this.$i18n.getLocaleMessage(this.$i18n.locale).limo;
    },
    tours() {
      return this.$i18n.getLocaleMessage(this.$i18n.locale).tours;
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 1159
    },
    customFormat(date) {
      if (!date) return "";
      const formattedDate = new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
        month: "short",
        weekday: "short"
      }).format(new Date(date)); // Example: "09 Jan Thu"

      const formattedTime = new Intl.DateTimeFormat("en-US", {
        hour: "2-digit",
        minute: "2-digit"
      }).format(new Date(date)); // Example: "10:00"

      return `${formattedDate}  ${formattedTime}`;
    },
    sendBox(formData) {
      this.isLoadingBox = true;
      formData.category = 'Limo'
      emailjs
          .send(
              "service_f7rqc6t",
              "template_mbhipw5",
              formData,
              "-zEI4YqttQNgREkFa"
          )
          .then(() => {
            this.submittedBox = true;
            this.emailErrorBox = false;
            this.isLoadingBox = false;
          })
          .catch((error) => {
            console.error("Greška:", error);
            this.emailErrorBox = true;
            this.submittedBox = true;
            this.isLoadingBox = false;
          });
    },
    sendEmail(formData, category) {
      this.isLoading = true;
      formData.category = category
      if (category !== 'limo') {
        formData.message = 'broj osoba:' + this.numOfPpl
      }
      emailjs
          .send(
              "service_f7rqc6t",
              "template_mbhipw5",
              formData,
              "-zEI4YqttQNgREkFa"
          )
          .then(() => {
            this.submittedBox = true;
            this.submitted = true;
            this.emailError = false;
            this.isLoading = false;
          })
          .catch((error) => {
            console.error("Greška:", error);
            this.emailError = true;
            this.submitted = true;
            this.isLoading = false;
          });
    },
  },
  created() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/main.scss";

.statistics-section-mobile {
  .transfer {
    gap: 20px !important;

    .content {
      .title {
        font-size: 30px !important;
        padding: 30px 0 15px !important;
      }

      .description {
        p {
          margin: 0;
          font-size: 10px;
        }
      }

      .cards {
        width: 100vw !important;
        gap: 15px !important;
        .single-card {
          align-items: center !important;

          img {
            max-width: 170px !important;
          }

          .car {
            align-items: center !important;
            justify-content: center !important;
            text-align: center !important;

            .title {
              padding: 15px 0 5px !important;
              font-size: 14px !important;
            }
            .sub-title {
              font-size: 8px !important;
            }
          }
        }
      }
    }

    .reservation-box {
      padding: 10px !important;
      width: 80% !important;
      bottom: -70% !important;

      h2 {
        text-transform: uppercase;
      }

      form {
        display: flex;
        flex-direction: column;
        gap: 10px;

        input, textarea {
          width: 300px !important;

          &::placeholder {
            font-size: 13px !important;
            line-height: 31px;
            text-transform: uppercase;
          }
        }
      }
    }

    .btn {
      font-size: 15px !important;
      padding: 10px !important;
    }
  }

  .tours {
    background-color: $darker-blue;
    position: relative;

    .background-image {
      width: 100%;
      height: 800px !important;
      object-fit: cover;
      border-bottom: 1px solid #232438;
      padding-bottom: 150px !important;
    }

    .tours-content {
      gap: 20px !important;
      .title {
        font-size: 30px !important;
        padding-bottom: 20px !important;
      }
      .description {

        p {
          line-height: 15px !important;
          margin: 0 !important;
          font-size: 10px !important;
        }
      }

      .section-title {
        padding: 30px 0 0 !important;
        font-size: 30px !important;
      }

      .title {
        font-size: 25px !important;
        padding-top: 20px !important;
      }

      .cards {
        gap: 10px !important;
        width: 99% !important;

        &:hover .cards {
          filter: blur(5px);
        }

        .single-card {
          max-width: 100px !important;

          p {
            font-size: 10px !important;
          }

          img {
            max-width: 100px !important;
          }
        }
      }

    }
  }

  .quick-reserv {
    height: 150px !important;
    border-bottom: 7px solid #232438;

    .form-box {
      padding: 10px !important;
      width: 80% !important;
      top: -110% !important;

      form {
        flex-direction: column;
        gap: 20px !important;
      }
      .title {
        font-size: 20px !important;
      }
    }

    .btn {
      width: 100%;
      font-size: 15px !important;
    }
  }
}

.statistics-section {
  width: 100%;
  background-color: white;
  //  padding-bottom: 50px;
  align-items: center;

  .transfer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    position: relative;
    margin-bottom: 250px;

    .content {
      font-family: 'Inter-Regular', 'Inter', sans-serif;
      color: $darker-blue;
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 30px;

      .title {
        text-transform: uppercase;
        font-size: 60px;
        font-weight: bold;
        padding: 100px 0 30px;
      }

      .description {
        text-align: center;
        font-size: 20px;
        color: $darker-blue;

        p {
          line-height: 15px;
        }
      }

      .cards {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 50px;

        .single-card {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          transition: transform 0.4s ease-out, opacity 0.6s ease-in !important;
          will-change: transform !important;

          img {
            max-width: 666px;
          }

          .car {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;

            .title {
              padding: 20px 0 5px;
              font-family: 'Inter-Regular', 'Inter', sans-serif;
              color: #232428;
              text-transform: uppercase;
              font-size: 20px;
            }

            .sub-title {
              color: #9D9D9D;
              text-transform: uppercase;
              font-size: 14px;
            }
          }

          &:hover {
            color: #FFFFFF;
            transform: scale(1.05) translateY(0px) !important;
            transition: transform 2s ease-out !important;
          }
        }

        &.animate {
          opacity: 1;

          .left {
            animation: slideInFromLeft 2s forwards;
          }

          .left2 {
            animation: slideInFromLeft 3s forwards;
          }

          .right {
            animation: slideInFromRight 4s forwards;
          }

          .right2 {
            animation: slideInFromRight 4.5s forwards;
          }
        }

        @keyframes slideInFromLeft {
          0% {
            transform: translateX(-100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes slideInFromRight {
          0% {
            transform: translateX(100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }
      }
    }

    .reservation-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 20px;
      width: 70%;
      background-color: rgb(85 172 173 / 30%);
      backdrop-filter: blur(30px);
      border-radius: 15px;
      border: 1px solid #9D9D9D;
      position: absolute;
      z-index: 1;
      bottom: -32%;
      left: 50%;
      transform: translateX(-50%);

      h2 {
        text-transform: uppercase;
      }

      form {
        display: flex;
        flex-direction: column;
        gap: 10px;

        input, textarea {
          width: 400px;
          background-color: white;
          color: #9D9D9D;
          font-size: 20px;
          text-transform: uppercase;
          border: 1px solid $darker-blue;
          border-radius: 10px;
          padding: 10px;
          resize: none;

          &::placeholder {
            color: #9D9D9D;
            font-family: Inter, sans-serif;
            //  font-weight: 400;
            font-size: 18px;
            line-height: 31px;
            text-transform: uppercase;
          }
        }
      }

    }

    .flex {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      img {
        max-width: 25px;
        margin: 3px;
      }
    }
    .btn {
      font-family: Inter, sans-serif;
      font-size: 20px;
      text-transform: uppercase;
      background-color: $primary-blue;
      color: white;
      font-weight: 600;
      border: none;
      border-radius: 10px;
      padding: 15px 20px;
      margin: 10px 0 0 30px;
      width: 50%;
    }
  }

  .tours {
    background-color: $darker-blue;
    position: relative;

    .background-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      padding: 0 0 50px 0;
    }

    .tours-content {
      font-family: 'Inter-Regular', 'Inter', sans-serif;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: $darker-blue;
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 30px;
      width: 100%;

      .title {
        font-family: Inter, sans-serif;
        font-weight: bold;
        font-size: 40px;
        color: #FFFFFF;
        text-transform: uppercase;
        padding-top: 30px;
      }

      .description {
        font-family: Inter, sans-serif;
        font-style: normal;
        font-size: 15px;
        color: #FFFFFF;
        text-align: center;

        p {
          line-height: 15px;
        }
      }

      .section-title {
        padding: 120px 0 10px;
        font-family: Inter, sans-serif;
        display: flex;
        align-items: center;
        text-transform: uppercase;

        font-weight: bold;
        font-size: 55px;
        color: #FFFFFF;
      }

      .cards {
        font-family: Inter, sans-serif;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 30px;
        width: 95%;

        &:hover .single-card {
          filter: blur(1px);
        }

        .single-card {
          max-width: 444px;
          font-weight: bold;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          transition: transform 0.3s ease-out, filter 0.3s ease;
          will-change: transform;

          p {
            color: #FFFFFF;
            text-transform: uppercase;
            font-size: 16px;
          }

          &:hover {
            transform: scale(1.1);
            border-radius: 30px;
            filter: blur(0);
          }
        }
      }
    }

  }
}

.quick-reserv {
  background-color: $darker-blue;
  width: 100%;
  height: 120px;
  position: relative;

  .form-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    width: 70%;
    background-color: rgb(240 240 240 / 18%);
    backdrop-filter: blur(30px);
    border-radius: 15px;
    border: 1px solid #9D9D9D;
    position: absolute;
    z-index: 1;
    top: -70%;
    left: 50%;
    transform: translateX(-50%);

    .title {
      font-family: Inter-Semibold, sans-serif;
      color: white;
      text-transform: uppercase;
      font-size: 30px;
      margin-bottom: 10px;
    }

    form {
      display: flex;
      gap: 35px;
      width: 85%;
      align-items: flex-start;

      .form-group {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
      }

      .picker {
        border-radius: 10px !important;
      }

      input, select {
        background-color: white;
        color: #9D9D9D;
        font-size: 16px;
        border: 1px solid $darker-blue;
        border-radius: 8px;
        padding: 10px;

        &::placeholder {
          color: #9D9D9D;
          font-family: Inter, sans-serif;
          //  font-weight: 400;
          font-size: 16px;
          line-height: 31px;
        }
      }

      .custom-datepicker {
        display: flex;
        align-items: center;
        background: white;
        border-radius: 10px;
        padding: 5px 10px;
        border: 1px solid #ddd;
        cursor: pointer;
        min-width: 140px;
      }

      .custom-datepicker .date {
        font-size: 18px;
        font-weight: bold;
        color: #0099a8; /* Plava boja kao na slici */
        margin-right: 5px;
      }

      .custom-datepicker .time {
        font-size: 14px;
        color: #666;
      }
    }

  }

  .btn {
    text-transform: uppercase;
    background-color: $primary-blue;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 10px;
    padding: 10px 40px;
    font-size: 16px;
  }

}

.confirmation {
  color: white;
  text-align: center;
  animation: fadeIn 0.3s ease-in-out;
}

.confirmation p {
  font-size: 16px;
  margin: 10px 0;
}

.box {
  padding: 60px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid $primary-blue;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

::v-deep {
  .dp__menu {
    bottom: 100% !important;
    top: auto !important;
  }

  .dp__input {
    padding: 10px;
    border-radius: 10px;

    &::placeholder {
      //   color: rgba(255, 255, 255, 0.68);
    }
  }

  .dp__active_date {
    background: $primary-blue !important;
  }

  .dp__today {
    border: 1px solid $primary-blue !important;
  }

  .dp__action_buttons .dp__action_select {
    background: $primary-blue !important;
  }

  .dp__inc_dec_button:hover {
    color: $primary-blue !important;
  }

  .dp__action_cancel:hover {
    border-color: $primary-blue !important;
  }

  .dp__action_buttons .dp__action_select:hover {
    background: rgba(85, 172, 173, 0.48) !important;
  }
}

</style>
